export default __webpack_public_path__ + "static/media/vect-carousel-login.bb1c0a43.svg";